/**
 * Slug do credor principal como ele aparece em `assets/images/logo-credores`, a partir do
 * `divida.logo` cru. O prefixo `mc-` e o sufixo de rota vêm da API; os apelidos cobrem credores
 * cujo arquivo de logo tem outro nome.
 *
 * Quem resolve cor de credor usa a mesma chave que quem resolve a imagem, para as duas nunca
 * discordarem no mesmo card.
 */

const APELIDOS: Record<string, string> = {
  acerto: 'acerto-inter',
  'porto-seguro': 'porto',
};

const PREFIXO_MC = 'mc-';

/** Sem regex: `\/.*$` volta atrás a cada `/` quando há quebra de linha depois dela (O(n²)). */
function removerPrefixoESufixo(slug: string): string {
  const fimDaRota = slug.indexOf('/');
  const semSufixo = fimDaRota === -1 ? slug : slug.slice(0, fimDaRota);
  return semSufixo.startsWith(PREFIXO_MC) ? semSufixo.slice(PREFIXO_MC.length) : semSufixo;
}

export function normalizarSlugCredor(slug: string): string {
  const limpo = removerPrefixoESufixo(slug).toLowerCase();
  // Checagem de chave própria porque o slug vem da API: sem ela uma chave como `constructor`
  // devolveria o membro herdado do prototype. `hasOwnProperty.call`, e não `Object.hasOwn`, porque o
  // build não tem polyfill e o `LogoCredor` roda em toda tela, inclusive no iOS anterior ao 15.4.
  return Object.prototype.hasOwnProperty.call(APELIDOS, limpo) ? APELIDOS[limpo] : limpo;
}
